import { Col, List } from "antd";
interface DataItem {
  [key: string]: any;
}
const BodyList = ({ data, header, setPage, page, total, isLoading }: any) => {
  const handlePageChange = (page: number) => {
    console.log("Changing to page: ", page);
    setPage(page); // Directly set the new page number
    // Optionally fetch data here if your data fetching logic is not elsewhere
  };
  const getFallbackText = (key: any, value: any) => {
    if (value === null) {
      if (key === "cancellation_date") {
        return "No cancellation";
      }
      return "null";
    }
    return value?.toString() || value;
  };

  return (
    <div>
      {data?.length > 0 ? ( // Check if data is not empty
        <List
          size="large"
          style={{ marginBottom: "16px" }}
          header={
            header && (
              <div className="mb-1 text-base font-semibold text-color-primary">
                {header}
              </div>
            )
          }
          dataSource={data || []}
          pagination={{
            total: total,
            pageSize: 15,
            current: page,
            position: "bottom",
            onChange: handlePageChange,
          }}
          renderItem={(item) => (
            <List.Item className="mb-2">
              {Object.entries(item as DataItem).map(
                ([key, value], index, array) => (
                  <Col
                    key={index}
                    className={`text-[#75757E] ${
                      header && index > 0 && "text-color-primary"
                    } !border-0 bg-white max-lg:min-w-[150px] w-full py-3 min-h-[44px] font-semibold ${
                      index === 0 ? "px-3 rounded-r-lg" : "" // Add rounded-l-lg to the first column
                    } ${
                      index === array.length - 1 ? "px-3 rounded-l-lg" : "" // Add rounded-r-lg to the last column
                    } text-center text-sm`}
                  >
                    {getFallbackText(key, value)}
                    {header && index > 0 && ` ر.س `}
                  </Col>
                )
              )}
            </List.Item>
          )}
        />
      ) : (
        <div className="text-center"></div>
      )}
    </div>
  );
};

export default BodyList;
